import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMotorcycle, faCar } from '@fortawesome/free-solid-svg-icons';
import { SERVICE_SEARCH_TIMEOUT_SEC, VEHICLE_TYPES } from '../../../../../constants';

export const SearchingRadarAnimation = ({ elapsed, vehicleType = VEHICLE_TYPES.MOTO }) => {
  const progressPercent = Math.min(100, Math.round((elapsed / SERVICE_SEARCH_TIMEOUT_SEC) * 100));
  const isCar = vehicleType === VEHICLE_TYPES.CARRO || vehicleType === 'carro';
  const vehicleLabel = isCar ? 'carro' : 'moto';

  return (
    <div className="text-center py-4 position-relative">
      <div className="position-relative d-inline-block mb-3">
        <motion.div
          animate={{ scale: [1, 1.8, 1], opacity: [0.6, 0, 0.6] }}
          transition={{ repeat: Infinity, duration: 2, ease: 'easeInOut' }}
          className="rounded-circle position-absolute top-50 start-50 translate-middle"
          style={{
            width: '80px',
            height: '80px',
            backgroundColor: 'rgba(14, 171, 176, 0.25)',
            zIndex: 0
          }}
        />
        <motion.div
          animate={{ scale: [1, 2.4, 1], opacity: [0.4, 0, 0.4] }}
          transition={{ repeat: Infinity, duration: 2, delay: 0.5, ease: 'easeInOut' }}
          className="rounded-circle position-absolute top-50 start-50 translate-middle"
          style={{
            width: '80px',
            height: '80px',
            backgroundColor: 'rgba(14, 171, 176, 0.15)',
            zIndex: 0
          }}
        />
        <div
          className="rounded-circle d-flex align-items-center justify-content-center position-relative shadow-lg"
          style={{
            width: '70px',
            height: '70px',
            backgroundColor: 'var(--bry-accent, #0EABB0)',
            color: '#ffffff',
            zIndex: 1
          }}
        >
          <FontAwesomeIcon icon={isCar ? faCar : faMotorcycle} size="2x" />
        </div>
      </div>

      <h5 className="fw-bold text-white mb-1">Buscando conductor ({vehicleLabel})...</h5>
      <p className="text-gray-300 small mb-3">Conectando con conductores disponibles de la flota Bryemma en El Tigre</p>

      {/* Progress Bar Verde Turquesa */}
      <div className="mx-auto rounded-pill overflow-hidden" style={{ maxWidth: '280px', height: '6px', backgroundColor: 'rgba(255, 255, 255, 0.2)' }}>
        <div
          className="h-100 transition-all"
          style={{
            width: `${progressPercent}%`,
            backgroundColor: 'var(--bry-accent, #0EABB0)',
            borderRadius: '999px'
          }}
        />
      </div>
      <span className="text-gray-400 extra-small d-block mt-1">
        Tiempo transcurrido: {elapsed}s / {SERVICE_SEARCH_TIMEOUT_SEC}s
      </span>
    </div>
  );
};

export default SearchingRadarAnimation;
